import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import { ListItem, Divider, FlatButton } from 'material-ui';
// import KFlatButton from 'components/KJRN/KFlatButton';

import TMessage from './TMessage';
import TLoading from './TLoading';
import pallet from '../../constants/colors';

const styles = {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 20px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 10,
    paddingBottom: 10,
  },
  evaluation: {
  },
  evaluationInner: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 26,
    paddingBottom: 26,
  },
  tag: {
    marginTop: 12,
    borderRadius: 4,
    padding: 6,
    color: 'white',
    display: 'table',
  },
  actionButton: {
    fontWeight: 600,
    color: pallet.primary1Color,
    maxWidth: 150,
    textTransform: 'uppercase',
    backgroundColor: 'transparent',
  }
};
/* eslint-disable-next-line react/prefer-stateless-function */
class TEvaluations extends React.Component {
  render() {
    const {
      evaluations,
      evaluationsLoaded,
      // evaluationsError,
      hasError,
    } = this.props;

    if (hasError) {
      return <TMessage type="error" message="tile.evaluation.error" />;
    }

    if (!evaluationsLoaded) {
      return <TLoading />;
    }

    if (!evaluations || !evaluations.length) {
      return <TMessage message="tile.evaluation.empty" />;
    }

    // const text = { 0: 'tile.evaluation.start', 1: 'tile.evaluation.handin' };
    // const statusStyle = { 0: { backgroundColor: pallet.errorColor }, 1: { backgroundColor: pallet.warningColor } };

    return (
      <div style={styles.container} data-cy="evaluations">
        {evaluations.map((x, i) => (
          <div key={i}>
            <ListItem
              disabled
              hoverColor="transparent"
              style={styles.evaluation}
              innerDivStyle={styles.evaluationInner}
              // onClick={() => this.context.router.push(`/evaluation/${x.CourseAttendeeID}`)}
              primaryText={(
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>{x.CourseName}</div>
                  <div>
                    {/* <KFlatButton
                      style={styles.actionButton}
                      onClick={() => this.context.router.push(`/evaluation/${x.CourseAttendeeID}`)}
                      containerStyle={styles.action}
                      label={<FormattedMessage id="answer" />}
                    /> */}
                    <FlatButton
                      label={<FormattedMessage id="answer" />}
                      primary
                      style={styles.actionButton}
                      onClick={() => this.context.router.push(`/evaluation/${x.CourseAttendeeID}`)}
                    />
                  </div>
                </div>
              )}
            // secondaryText={
            //   <div style={{ ...statusStyle[x.EvaluationStatus], ...styles.tag }}>
            //     <FormattedMessage id={text[x.EvaluationStatus]} />
            //   </div>
            // }
            />
            <Divider />
          </div>
        ))}
      </div>
    );
  }
}

TEvaluations.propTypes = {
  evaluations: PropTypes.array.isRequired,
  hasError: PropTypes.bool.isRequired,
  // evaluationsError: PropTypes.object,
  evaluationsLoaded: PropTypes.bool.isRequired,
};

TEvaluations.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(({ CourseEvaluationReducer }) => ({ ...CourseEvaluationReducer }))(TEvaluations);



// WEBPACK FOOTER //
// ./src/containers/tiles/TEvaluations.js